/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var e;!function(e){e[e.RecreateSymbol=0]="RecreateSymbol",e[e.RecreateGraphics=1]="RecreateGraphics",e[e.FastUpdate=2]="FastUpdate"}(e||(e={}));export{e as ApplyRendererDiffResult};
